import { BoxDisplay } from '../Common/types';
import { ReactNode } from 'react';
import { StyledBox } from '../Common/StyledBox';
import { CommonBoxProps, resolveCommonBoxProps } from '../Common/boxUtils';

type BoxProps = CommonBoxProps & {
  display?: BoxDisplay;
  children?: ReactNode;
};

export const Box = ({
  children,
  padding,
  paddingX,
  paddingY,
  paddingLeft,
  paddingRight,
  paddingBottom,
  paddingTop,
  margin,
  marginX,
  marginY,
  marginLeft,
  marginRight,
  marginBottom,
  marginTop,
  borderWidth,
  borderWidthLeft,
  borderWidthRight,
  borderWidthTop,
  borderWidthBottom,
  borderColor,
  display,
  isolate,
  position,
  width,
  height,
  backgroundColor,
  boxShadow,
  borderRadius,
  flexGrow,
  flexShrink,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  overflow,
  overflowX,
  overflowY,
  zIndex,
  transition,
  ...rest
}: BoxProps) => {
  const commonBoxProps = resolveCommonBoxProps({
    padding,
    paddingX,
    paddingY,
    paddingLeft,
    paddingRight,
    paddingBottom,
    paddingTop,
    margin,
    marginX,
    marginY,
    marginLeft,
    marginRight,
    marginBottom,
    marginTop,
    borderWidth,
    borderWidthLeft,
    borderWidthRight,
    borderWidthTop,
    borderWidthBottom,
    borderColor,
    isolate,
    position,
    width,
    height,
    backgroundColor,
    boxShadow,
    borderRadius,
    flexGrow,
    flexShrink,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    overflow,
    overflowX,
    overflowY,
    zIndex,
    transition,
  });
  return (
    <StyledBox {...commonBoxProps} $display={display} {...rest}>
      {children}
    </StyledBox>
  );
};
